var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvprofileImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.71717C7.00128 8.5275 7.07483 8.34596 7.20476 8.21177C7.33469 8.07758 7.51057 8.00151 7.6944 8H20.3056C20.6892 8 21 8.32139 21 8.71717V20.2828C20.9987 20.4725 20.9252 20.654 20.7952 20.7882C20.6653 20.9224 20.4894 20.9985 20.3056 21H7.6944C7.51017 20.9998 7.33355 20.9242 7.20334 20.7897C7.07314 20.6552 7 20.4729 7 20.2828V8.71717ZM8.4 9.44444V19.5556H19.6V9.44444H8.4ZM9.8 10.8889H14V15.2222H9.8V10.8889ZM11.2 12.3333V13.7778H12.6V12.3333H11.2ZM9.8 16.6667H18.2V18.1111H9.8V16.6667ZM15.4 10.8889H18.2V12.3333H15.4V10.8889ZM15.4 13.7778H18.2V15.2222H15.4V13.7778Z",
    fill: "#5C5C5C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#A9A9A9",
    strokeOpacity: 0.51
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvprofileImage);
export default __webpack_public_path__ + "static/media/cvprofile_image.bdf00476b69bcec5fc8442a1e78db1c9.svg";
export { ForwardRef as ReactComponent };